import { nodeAdapter } from "./runtime";
import { runServer } from "./server.impl";

await runServer(nodeAdapter);
